import { render } from "./DefPicture.vue?vue&type=template&id=8939c8a6&scoped=true"
import script from "./DefPicture.vue?vue&type=script&lang=js"
export * from "./DefPicture.vue?vue&type=script&lang=js"

import "./DefPicture.vue?vue&type=style&index=0&id=8939c8a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8939c8a6"]])

export default __exports__